module.exports = __webpack_public_path__ + "img/scene2-3D.7b9934b2.gif";